import moment from 'moment';
import * as actionTypes from '../constants/actionTypes';
import {getApiConfig, inRange} from '../utilities';
import {checkApiError} from '../utilities/backend';
import * as misc from './../misc';
import * as _ from 'lodash';
import {errorBox_Show, messageBox_Show} from "./A_Popups";
import {AccessRights} from "../schemas/accessRightsModel";
import {JOB_DOCUMENT_TYPES} from "../utilities/constants";

/**
 * Gets the schedule entries for a job
 * @param {int} month
 * @param {int} day
 * @param {boolean} dispatchSelectDay
 * @returns {Function}
 */
export function fetchJobScheduleEntries(month, day, dispatchSelectDay = true) {
  return function (dispatch, getState) {
    const state = getState();
    const {calendar} = state;
    const m = moment(calendar.visibleYear);

    dispatch({
      type: actionTypes.CALENDAR_FETCHING_ENTRIES,
      payload: {month, day}
    });

    const AR = AccessRights.get(state);
    const isClient = AR.isClient();

    if (dispatchSelectDay) {
      dispatch({
        type: actionTypes.CALENDAR_SELECT_DAY,
        payload: {month, day}
      });
    }

    const {post} = getApiConfig('JobBoard/GetScheduleEntries');
    post({
      jobId: calendar.job.id,
      jobIdType: calendar.job.jobIdType,
      leadType: calendar.job.leadType,
      type: calendar.job.type,
      date: `${month + 1}/${day}/${m.year()}`
    }).then(data => {
      _.each(data.notes, note => {
        note.noteTimestamp = misc.toMoment(note.noteTimestamp);
      });
      dispatch({
        type: actionTypes.CALENDAR_FETCHED_ENTRIES,
        payload: data,
        isClient,
      });
      dispatch({
        type: actionTypes.POPUP_IN_PROGRESS,
        payload: {
          show: false
        }
      });
    });
  }
}

/**
 *
 * @param {string} which (next | prev)
 */
export function selectYear(which) {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.CALENDAR_SELECT_YEAR,
      payload: which
    });
  }
}

export function showScheduleEntry(show, isNew, entry = null) {
  return function (dispatch) {
    return dispatch({
      type: actionTypes.CALENDAR_SHOW_SCHEDULE_ENTRY,
      payload: {show, isNew, entry}
    });
  }
}

/**
 * Shows the schedule entry only for typing notes and uploading documents for a job.
 * @param job {object}
 * @param show {boolean}
 * @param what {string} NOTES | DOCS (see Enums.TABS)
 * @return {Function}
 */
export function showScheduleEntryNotesDocumentsOnly(job, show, what) {
  return function (dispatch, getState) {

    dispatch({
      type: actionTypes.CALENDAR_FETCHING_ENTRIES
    });

    const AR = AccessRights.get(getState());
    const isClient = AR.isClient();

    const {post} = getApiConfig('JobBoard/GetScheduleEntries');
    post({
      jobId: job.id,
      jobIdType: job.jobIdType,
      leadType: job.leadType,
      type: job.type,
      date: null
    }).then(data => {
      _.each(data.notes, note => {
        note.noteTimestamp = misc.toMoment(note.noteTimestamp);
      });
      dispatch({
        type: actionTypes.CALENDAR_FETCHED_ENTRIES,
        payload: data,
        isClient,
      });
    });

    dispatch({
      type: actionTypes.CALENDAR_SHOW_SCHEDULE_ENTRY_DOCS_DOCUMENTS_ONLY,
      payload: {job, show, what}
    });
  }
}

export function saveScheduleEntry(entryData) {
  return function (dispatch, getState) {

    const {am, time} = entryData;
    const timeParts = time.split(':');
    let hour = +timeParts[0];
    const minute = +timeParts[1];

    if (am && hour === 12)
      hour = 0;
    let ok = true;
    if (am && (inRange(hour, minute, 0, 0, 4, 59)))
      ok = false;
    if (ok && !am && inRange(hour, minute, 11, 0, 11, 59))
      ok = false;
    if (!ok) {
      errorBox_Show({text: 'Appointments cannot be scheduled between 11:00PM and 05:00AM.'})(dispatch, getState);
      return;
    }

    dispatch({
      type: actionTypes.POPUP_IN_PROGRESS,
      payload: {
        show: true,
        title: 'Saving...',
        message: 'Please wait while we are storing your changes.'
      }
    });

    dispatch({
      type: actionTypes.CALENDAR_SCHEDULE_ENTRY_SAVING,
      payload: true
    });

    const state = getState();
    const {post} = getApiConfig('JobBoard/SaveScheduleEntry');
    const {auth} = state;
    const {calendar} = state;
    const {job} = calendar;
    entryData.id = -1; //calendar.entry ? calendar.entry.id : -1;
    let jobId = job.id;
    let jobIdType = job.jobIdType;
    let jobType = job.type;

    if (calendar.entry) {
      entryData.id = calendar.entry.id;
      const scheduleEntry = calendar.entry.entry;
      jobId = scheduleEntry.jobId;
      jobIdType = scheduleEntry.jobIdType;
      jobType = scheduleEntry.jobIdType;
    }

    post({
      scheduleEntryData: entryData,
      jobId: jobId,
      jobIdType: jobIdType,
      jobType: jobType,
      jobSubType: job.subType,
      userId: auth.userId,
      customerId: auth.customerId,
      fabricatorId: auth.fabricatorId,
      scheduleEntryId: entryData.id
    })
      .then(data => {
        checkApiError(data, dispatch);

        dispatch({ // this updates appointments and closes popup
          type: actionTypes.CALENDAR_SCHEDULE_ENTRY_SAVED,
          payload: {job, properties: {"appointmentDate": [...(job.appointmentDate || []), calendar.selectedDate]}}
        });

        fetchJobScheduleEntries(calendar.selectedDate.month(), calendar.selectedDate.date(), false)(dispatch, getState);
      });
  }
}
/**
 *
 * @param {string} note
 * @returns {Function}
 */
export function saveJobNote(note) {
  return function (dispatch, getState) {
    dispatch({
      type: actionTypes.POPUP_IN_PROGRESS,
      payload: {
        show: true,
        title: 'Saving...',
        message: 'Please wait while we are storing your note.'
      }
    });

    const state = getState();
    const {job} = state.calendar;
    dispatch({
      type: actionTypes.JOB_BOARD_NOTE_SAVING,
      payload: {jobId: job.id, jobIdType: job.jobIdType}
    });

    const {post} = getApiConfig('JobBoard/SaveJobNote');
    post({
      jobId: job.id,
      jobIdType: job.jobIdType,
      noteText: note,
      noteTimestamp: new Date()
    })
      .then(data => {
        dispatch({
          type: actionTypes.POPUP_IN_PROGRESS,
          payload: {show: false}
        });

        //checkApiError(data, dispatch);
        if (!data.__error__) {
          data.noteTimestamp = misc.toMoment(data.noteTimestamp);
          dispatch({
            type: actionTypes.JOB_BOARD_NOTE_SAVED,
            payload: {jobId: job.id, jobIdType: job.jobIdType, note: data}
          });
        }
      });
  }
}

export const uploadJobFileRequest = (file, job = null, documentType = "") => {
  let formData = new FormData();
  const name = documentType === JOB_DOCUMENT_TYPES.order ? "Purchase Order.pdf" : undefined;
  formData.append('file', file, name);
  const data = {
    jobId: job.id,
    jobIdType: job.jobIdType,
    documentTimestamp: new Date(),
    documentType,
  };
  formData.append('json', JSON.stringify(data));
  return getApiConfig('JobBoard/UploadJobFile').post(formData)
}

export function uploadJobFile(file) {
  return function (dispatch, getState) {
    dispatch({
      type: actionTypes.POPUP_IN_PROGRESS,
      payload: {
        show: true,
        title: 'Uploading...',
        message: 'Please wait while we are uploading your document.'
      }
    });

    const state = getState();
    const {job} = state.calendar;
    dispatch({
      type: actionTypes.JOB_BOARD_DOCUMENT_SAVING,
      payload: {jobId: job.id, jobIdType: job.jobIdType}
    });

    uploadJobFileRequest(file, job)
      .then(data => {
        dispatch({
          type: actionTypes.POPUP_IN_PROGRESS,
          payload: {show: false}
        });

        if (!data.__error__) {
          data.documentTimestamp = misc.toMoment(data.documentTimestamp);
          dispatch({
            type: actionTypes.JOB_BOARD_DOCUMENT_SAVED,
            payload: {jobId: job.id, jobIdType: job.jobIdType, document: data}
          });
        }
      });
  }
}


